export const STATUS = {
  SUBMITTED: 'S',
  INVOICED: 'V',
  ACCEPTED: 'A',
  CANCELED: 'X',
};

export const NONAME = {
};
